// extracted by mini-css-extract-plugin
module.exports = {"full-width":"participant-modal-module__full-width___NP7sy"};